import { useNavigate } from "react-router-dom";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import ET3DataLink from "../../../../../../core/et3-shared-components/DataLink";
import getCorePersonalStore from "../../../../../../stores/core/core-personal-store";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";

const UserOptionsButton = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const userID = getUserAdvancedStore().currentUserId.get();
  const navigate = useNavigate();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={200}
      height={300}
      fDirection="column"
      alignItems="center"
      justifyContent="space-between"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3DataLink
        type={"button"}
        name={"USER_MESSAGES"}
        onPress={async () => {
          navigate({
            pathname: "/users/messages",
            search: `id=${userID}`
          });
          await getCorePersonalStore().insertAdminEvent({
            eventName: "GO_TO_MESSAGES",
            fromPage: "USER_ADVANCED",
            userID: userID,
            extraData: {}
          });
        }}
      />
      <ET3DataLink
        type={"button"}
        name={"USER_PAYMENTS"}
        onPress={async () => {
          navigate({
            pathname: "/users/payments",
            search: `id=${userID}`
          });
          await getCorePersonalStore().insertAdminEvent({
            eventName: "GO_TO_PAYMENTS",
            fromPage: "USER_ADVANCED",
            userID: userID,
            extraData: {}
          });
        }}
      />
      <ET3DataLink
        type={"button"}
        name={"USER_EVENTS"}
        onPress={async () => {
          navigate({
            pathname: "/users/events",
            search: `id=${userID}`
          });
          getUserAdvancedStore().goToUserEvents(userID);
          await getCorePersonalStore().insertAdminEvent({
            eventName: "GO_TO_EVENTS",
            fromPage: "USER_ADVANCED",
            userID: userID,
            extraData: {}
          });
        }}
      />
      <ET3DataLink
        type={"button"}
        name={"EDIT_USER_DATA"}
        onPress={async () => {
          navigate({
            pathname: "/users/editProfile",
            search: `id=${userID}`
          });
          await getCorePersonalStore().insertAdminEvent({
            eventName: "GO_TO_EDIT_PROFILE",
            fromPage: "USER_ADVANCED",
            userID: userID,
            extraData: {}
          });
        }}
      />
      <ET3DataLink
        type={"button"}
        name={"CONSUMABLES"}
        onPress={async () => {
          navigate({
            pathname: "/users/consumables",
            search: `id=${userID}`
          });
          await getCorePersonalStore().insertAdminEvent({
            eventName: "GO_TO_USER_CONSUMABLES",
            fromPage: "USER_ADVANCED",
            userID: userID,
            extraData: {}
          });
        }}
      />
    </ET3Div>
  );
});
export default UserOptionsButton;
